export const partners = {
  pacifico: "Pacífico",
  bcp: "BCP",
  mibanco: "MiBanco"
}

export const partnerTypes = {
  pacifico: "Pacífico",
  bcp: "BCP",
  mibanco: "MiBanco"
}


export const partner = {
  name: "Pacifico"
}

export const channels = {
  pacifico: "",
  bcp: "bcp",
  mibanco: "soatmibanco",
  yape: "yape"
}